import {
  collection,
  doc,
  serverTimestamp,
  writeBatch,
} from "firebase/firestore";
import { auth, dbAccounts } from "../../../../backend/firebaseConfig";
import { getOpeningBalanceDate } from "../utils/openingBalanceBulkUpload";
import { shouldIncludeClosingBalance } from "../utils/closingBalanceEligibility";
import { assertChargeDatesAreOpen } from "../utils/closedChargeMonths";

const payments = collection(dbAccounts, "MonthlyManualPayments");

const nextMonthKey = (month) => {
  const match = String(month || "").match(/^(\d{4})-(\d{2})$/);
  if (!match || Number(match[2]) < 1 || Number(match[2]) > 12) {
    throw new Error("Select a valid closing balance month.");
  }
  const nextMonth = new Date(Date.UTC(Number(match[1]), Number(match[2]), 1));
  return `${nextMonth.getUTCFullYear()}-${String(nextMonth.getUTCMonth() + 1).padStart(2, "0")}`;
};

export const saveClosingBalancesAsNextMonthOpeningBalances = async ({
  month,
  rows,
}) => {
  if (!Array.isArray(rows) || !rows.length) {
    throw new Error("There are no closing balances to carry forward.");
  }
  const openingMonth = nextMonthKey(month);
  const openingDate = getOpeningBalanceDate(openingMonth);
  await assertChargeDatesAreOpen([openingDate]);
  const user = auth.currentUser;
  const batch = writeBatch(dbAccounts);
  let count = 0;

  rows.filter(shouldIncludeClosingBalance).forEach((row) => {
    const email = String(row.email || "").trim().toLowerCase();
    const mappedEntityType = String(
      row.mappedEntityType || (row.isUnknown ? "unknown" : "adviser"),
    ).trim().toLowerCase();
    const mappedEntityId = String(
      row.mappedEntityId || email || row.rowKey || row.adviser || "",
    ).trim();
    if (!mappedEntityId) return;
    const recipientKey = email || `${mappedEntityType}:${mappedEntityId}`;
    batch.set(doc(payments, `carry-forward-${openingMonth}-${encodeURIComponent(recipientKey)}`), {
      recordType: "opening_balance",
      paymentType: "opening_balance",
      adviserEmail: email,
      adviserName: String(row.adviser || "").trim(),
      adviserId: row.adviserId || "",
      brandName: String(row.practice || "").trim(),
      mappedEntityType,
      mappedEntityId,
      mappedEntityName: String(row.adviser || "").trim(),
      ioIntroducerId: mappedEntityType === "introducer" ? mappedEntityId : null,
      date: new Date(`${openingDate}T00:00:00.000Z`).toISOString(),
      paymentMonth: openingMonth,
      description: "Closing Balance brought forward",
      openingBalanceAmount: Number(row.closingBalance || 0),
      amountPaid: 0,
      amountDeducted: 0,
      netAmount: 0,
      source: "closing_balance_carry_forward",
      sourceMonth: month,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      createdBy: {
        uid: user?.uid || "",
        email: user?.email || "",
        name: user?.displayName || user?.email || "",
      },
    });
    count += 1;
  });

  if (!count) throw new Error("There are no eligible closing balances to carry forward.");
  await batch.commit();
  return { count, openingMonth };
};
